export default __webpack_public_path__ + "static/media/redeem-bonus1-2.d7ec8a79.webp";